export default {
  path: '/licenses',
  name: 'licenses',
  component: () => import('./LicensesIndex'),
  meta: {
    requiresAuth: true
  }
}
